/* src/app/home-new/mobile-home-folders/mobile-home-folders.component.scss */
.folders-container {
  position: fixed;
  height: 100%;
  top: 85px;
  bottom: 0;
  z-index: 9999;
  background-color: #f6f6f6;
  width: 100%;
  padding: 20px;
}
hr {
  width: 100%;
  border-top: 1px solid #acacac;
}
.commentBox_label {
  font-weight: 500;
  font-size: 18px;
  margin-bottom: 10px;
}
.commentBox_textarea {
  --padding-top: 16px;
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-bottom: 10px;
  --background: white;
  --border-radius: 10px;
  --border-width: 0;
  font-weight: 400;
  font-size: 16px;
}
.commentBox_textarea textarea {
  overflow: auto;
  border: 1px solid #6f6f6f;
  border-radius: 10px;
  padding: 16px 10px;
  background: white;
}
.groups_title {
  font-size: 22px;
}
.groups_title ion-icon {
  margin-right: 10px;
  z-index: 99;
  cursor: pointer;
}
.groups_title h2 {
  font-weight: 600;
}
.create-group-button {
  margin-bottom: 10px;
}
.create-group-button span {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 1px;
}
.create-group-button ion-icon {
  margin-right: 5px;
  font-size: 14px;
  fill: white;
}
.groups_list {
  height: 560px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 10px;
  padding-bottom: 100px;
}
/*# sourceMappingURL=mobile-home-folders.component-H62FQ73Q.css.map */
